<template>
  <li class="chat-list-item" :class="{ active: isActive }">
    <div class="chat-list-item-wrapper">
      <section class="chat-item-main">
        <header class="d-flex align-items-center justify-content-between mb-1">
          <h6 class="chat-title">
            {{ chat.nama_pemrakarsa }}
          </h6>
          <!-- <span class="ms-auto timestamp">
            {{ formatDateString(chat.last_message_time) }}
          </span> -->
        </header>
        <!-- <p class="chat-last-message">
          {{ chat.last_message }}
        </p> -->
      </section>
    </div>
  </li>
</template>

<script>
import { ChatMixin } from '@/mixins/chat'
import { formatDateString } from '../../../../helper/helpernew'

export default {
  name: 'ChatListItem',
  mixins: [ChatMixin],
  props: {
    chat: { type: Object, default: () => {} },
    isActive: { type: Boolean, default: false },
  },
  methods: {
    formatDateString,
  },
  // computed: {
  //   time() {
  //     return moment(this.chat.lastMessage?.timestamp).format('D MMM') || ''
  //   },
  //   chatUsers() {
  //     if (this.chat.interlocutors.length <= 2) {
  //       return [...this.chat.interlocutors, this.user]
  //     } else {
  //       return this.chat.interlocutors.slice(0, 3)
  //     }
  //   },
  // },
}
</script>

<style src="./ChatList.scss" lang="scss" scoped></style>
